var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinPickup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_84779_22673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 56.0005C31.8659 56.0005 35 52.8666 35 49.0005C35 45.1346 31.8659 42.0005 28 42.0005C24.1339 42.0005 21 45.1346 21 49.0005C21 52.8666 24.1339 56.0005 28 56.0005Z",
    fill: "#171B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 30H29V47H27V30Z",
    fill: "#171B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 32C36.8365 32 44 24.8366 44 16.0001C44 7.1634 36.8365 0 28 0C19.1634 0 12 7.1634 12 16.0001C12 24.8366 19.1634 32 28 32Z",
    fill: "#3BD4AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 21C30.7612 21 33 18.7613 33 16.0001C33 13.2387 30.7612 11 28 11C25.2386 11 23 13.2387 23 16.0001C23 18.7613 25.2386 21 28 21Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_84779_22673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinPickup);
export default __webpack_public_path__ + "static/media/pin-pickup.3da69288b5ce428704dc92b9a10daed3.svg";
export { ForwardRef as ReactComponent };